<table class="tabla-dias table table-sm table-borderless">
  <tbody>
    <tr class="dia-container-habilitado mt-3" *ngFor="let item of fecha">
      <td style="width: 20%">
        <i
          class="fa-sharp fa-solid fa-circle-check"
          style="font-size: 20px; color: #118565"
        ></i>
      </td>
      <td>
        <div class="row" style="color: #00549d">
          <div class="col-lg-12" style="font-size: 13px">
            {{
              item.fecha
                ? (item.fecha | date : 'EEEE dd MMMM, y ')
                : ('' | titlecase)
            }}
          </div>
          <div
            class="col-lg-12"
            *ngIf="item.precio > 0"
            style="font-size: 13px"
          >
            <strong>{{ item.precio | currency }}</strong>
          </div>
          <div
            class="col-lg-12"
            *ngIf="item.precio == 0"
            style="font-size: 14px"
          >
            <strong>Gratis</strong>
          </div>
        </div>
      </td>
      <td>
        <div class="row" style="color: #00549d">
          <div class="col-lg-12" style="font-size: 13px">
            <i class="far fa-calendar-check"></i>
          </div>
          <div class="col-lg-12" style="font-size: 13px">Entrega</div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
